import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { IframeEmbedBlockAttsInterface } from '~/types/AppData/Blocks/IframeEmbedBlockInterface';
import type { EmbedType } from '~/components/Shared/Embeds/Embed';
import Embed from '~/components/Shared/Embeds/Embed';

export default component$(
  ({ embedCodeHTMLString }: IframeEmbedBlockAttsInterface): JSX.Element => {
    if (!embedCodeHTMLString) return <></>;

    let type: EmbedType['type'] = 'iframe';
    let isLoadedProp: EmbedType['isLoadedProp'];
    let loadScript: EmbedType['loadScript'];

    if (embedCodeHTMLString.includes('riddle.com')) {
      const isRiddleV1 = embedCodeHTMLString.indexOf('riddle_target') > -1;
      loadScript = isRiddleV1
        ? 'https://www.riddle.com/embed/files/js/embed.js'
        : 'https://www.riddle.com/embed/build-embedjs/embedV2.js';
      isLoadedProp = 'mmRiddleLoaded';
      type = 'riddle';
    }

    return (
      <Embed
        embed={embedCodeHTMLString}
        type={type}
        isLoadedProp={isLoadedProp}
        loadScript={loadScript}
      />
    );
  }
);
